import { NavigationGuard } from 'vue-router'
import { getMe } from 'vue-common/src/services/users.service'
import { UserRole } from 'vue-common/src/types'

export const authGuard: NavigationGuard = async (to, from, next) => {
  const user = await getMe()

  // if the user is readonly, return them to dashboard
  const clientUrl = process.env.VUE_APP_CLIENT_URI || 'http://localhost:4200'
  if (user.role === UserRole.READONLY) {
    window.location.replace(`${clientUrl}/dashboard?redirect=false`)
  }
  return next()
}
